import { makeVar } from '@apollo/client'
import { useRouter } from 'next/router'
import { usePrevious } from 'react-use'

import links from '@web/libs/constants/links'
import { Nullish } from '@web/types'

import { ServerProps } from './useGlobalStaticState'

export const previousLocationVar = makeVar<Nullish<string>>(null)

const useGlobalPreviousRoute = ({ referrer }: ServerProps) => {
  const router = useRouter()

  const currentPath = router.asPath ? `${links.MY_HOME}${router.asPath}` : undefined
  const previousPath = usePrevious(currentPath)
  previousLocationVar(previousPath ?? referrer)
}

export default useGlobalPreviousRoute
